// Mercer University's majors (#2739). Read on 2026-10-01 from the official
// Mercer University 2026-2027 Undergraduate Catalog, Degree Programs
// (catalogs.mercer.edu), grouped by the college or school the catalog lists
// each major under, with the degree as the catalog writes it. Only majors
// whose catalog page gives the Macon or Atlanta campus as the location are
// kept: the residential undergraduate programs a first-year applicant joins.
// Left out: programs located at the Regional Academic Centers (the College of
// Professional Advancement's majors and the Regional Academic Centers
// versions of business and education majors), the Second Degree Accelerated
// and RN-BSN nursing tracks (for students who already hold a degree or an RN
// license), the 4+1 bachelor's/master's programs, the Liberal Studies
// combined degrees, minors, certificates and teacher certifications. The B.S.E. is listed by its
// specializations, as the catalog lists it. Classical Studies and Criminal
// Justice (College of Liberal Arts and Sciences) give no location on their
// pages and are kept with their college.
const majors = {
    "slug": "mercer-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Mercer's official 2026-2027 Undergraduate Catalog offered on the Macon or Atlanta campus, grouped by the college or school that offers it. Programs at the Regional Academic Centers, minors and certificates are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "Mercer University 2026-2027 Undergraduate Catalog, Degree Programs",
                "url": "https://catalogs.mercer.edu/content.php?catoid=6&navoid=940"
            },
            "majors": [
                {
                    "name": "African and African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art: Art History Emphasis",
                    "degree": "B.A."
                },
                {
                    "name": "Art: Studio Emphasis",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Commerce",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computational Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Cybersecurity",
                    "degree": "B.A."
                },
                {
                    "name": "Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Global Development Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Health Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Information Science and Technology",
                    "degree": "B.A."
                },
                {
                    "name": "Information Science and Technology",
                    "degree": "B.S."
                },
                {
                    "name": "International Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Latin",
                    "degree": "B.A."
                },
                {
                    "name": "Law and Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Multidisciplinary Studies, Emphasis in Arts and Humanities Additional Depth",
                    "degree": "B.A."
                },
                {
                    "name": "Multidisciplinary Studies, Emphasis in Arts and Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Multidisciplinary Studies, Emphasis in Social Science Additional Depth",
                    "degree": "B.A."
                },
                {
                    "name": "Multidisciplinary Studies, Emphasis in Social Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy, Politics, and Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Southern Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish, Emphasis in Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish, Emphasis in Medical Purposes",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "Mercer University 2026-2027 Undergraduate Catalog, Degree Programs",
                "url": "https://catalogs.mercer.edu/content.php?catoid=6&navoid=940"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "General Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "B.B.A."
                },
                {
                    "name": "Sports Marketing and Analytics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.B.A."
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "Mercer University 2026-2027 Undergraduate Catalog, Degree Programs",
                "url": "https://catalogs.mercer.edu/content.php?catoid=6&navoid=940"
            },
            "majors": [
                {
                    "name": "Human-Centered Information Design and Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Management",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering, Biomedical Specialization (Pre-Medical/Science Path)",
                    "degree": "B.S.E."
                },
                {
                    "name": "Engineering, Biomedical Specialization (Traditional Path)",
                    "degree": "B.S.E."
                },
                {
                    "name": "Engineering, Civil Specialization",
                    "degree": "B.S.E."
                },
                {
                    "name": "Engineering, Computer Specialization",
                    "degree": "B.S.E."
                },
                {
                    "name": "Engineering, Electrical Specialization",
                    "degree": "B.S.E."
                },
                {
                    "name": "Engineering, Environmental Specialization",
                    "degree": "B.S.E."
                },
                {
                    "name": "Engineering, Industrial Specialization",
                    "degree": "B.S.E."
                },
                {
                    "name": "Engineering, Mechanical Specialization",
                    "degree": "B.S.E."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Mercer University 2026-2027 Undergraduate Catalog, Degree Programs",
                "url": "https://catalogs.mercer.edu/content.php?catoid=6&navoid=940"
            },
            "majors": [
                {
                    "name": "Computer Science Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Health and Physical Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "The Holistic Child",
                    "degree": "B.S.Ed."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Mercer University 2026-2027 Undergraduate Catalog, Degree Programs",
                "url": "https://catalogs.mercer.edu/content.php?catoid=6&navoid=940"
            },
            "majors": [
                {
                    "name": "Nursing, Traditional Prelicensure Track",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "School of Music",
            "source": {
                "label": "Mercer University 2026-2027 Undergraduate Catalog, Degree Programs",
                "url": "https://catalogs.mercer.edu/content.php?catoid=6&navoid=940"
            },
            "majors": [
                {
                    "name": "Elective Studies in an Outside Field",
                    "degree": "B.M."
                },
                {
                    "name": "Music Business",
                    "degree": "B.S."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M.E."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Production",
                    "degree": "B.M."
                }
            ]
        },
        {
            "name": "College of Health Professions",
            "source": {
                "label": "Mercer University 2026-2027 Undergraduate Catalog, Degree Programs",
                "url": "https://catalogs.mercer.edu/content.php?catoid=6&navoid=940"
            },
            "majors": [
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
